"use strict";

exports.__esModule = true;

/* eslint-disable import/no-dynamic-require, global-require */

exports.default = function (contentType) {
    try {
        return require("../img/marketplace-content-types/" + contentType + ".png");
    } catch (e) {
        return null;
    }
};